<wms-dialog-header title={{locale.LABEL_ADD_PAGE_SELECT_LAYOUT}} class="change-layout-dialog large wm-studio-dialog" (onClose)="close()"></wms-dialog-header>
<wms-dialog-body >
  <wms-page-template [baseScreen]="baseScreen" [layouts]="layouts" (layoutSelected)="layoutSelected($event)" [activeLayout]="activeLayout"></wms-page-template>
</wms-dialog-body>

<wms-dialog-footer>
  <button type="button" name="btn-back" class="btn btn-secondary" (click)="close()" title="{{locale.LABEL_CANCEL}}">
    <span class="btn-caption">{{locale.LABEL_CANCEL}}</span>
  </button>
  <button type="button" name="btn-create-page" class="btn btn-primary" (click)="switchLayout()" title="{{locale.LABEL_APPLY}}">
    <span class="btn-caption">{{locale.LABEL_APPLY}}</span>
  </button>
</wms-dialog-footer>
